import { push } from "connected-react-router";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { currentAgentApplicationSelector } from "../../redux/selector/collectorApplicationSelector";
import { 
  APPLICATION_MODE_NEW,
  LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION,
  LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION,
  ROUTE_PATH 
} from "../../app/constants";
import {
  Header,
  Paragraph,
  Button,
  ErrorMark,
} from "../../components/RegularComponents";
import CheckboxForm from "../../components/CheckBoxForm";
import TopNavigationBar from "../TopNavigationBar";
import { ERROR_STRING } from "../../app/errors";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import { setCurrentAgentMortgageProperty } from "../../redux/slice/additionalApplicationsSlice";
import { applicationTypeFromLicenceSubType } from "../../redux/slice/applicationsUtils";

const MORTGAGE_APPLICATION_PROPERTY = "confirmEducationQualificationCompletion";

export const CompleteMortgageBrokerEducationOneYear = (props) => {
  const dispatch = useDispatch();
  const [confirmCheck, setConfirmCheck] = useState(false);
  const [showValidationError, setShowValidationError] = useState(false);
  const [applicationSaveError, setApplicationSaveError] = useState(false);

  const agentApplication = useSelector(currentAgentApplicationSelector);
  const licencingSubType = agentApplication?.licencingSubType ?? LICENCE_SUB_TYPE_MORTGAGE_BROKER_NEW_APPLICATION;
  const isPrincipalBroker = licencingSubType === LICENCE_SUB_TYPE_PRINCIPAL_BROKER_NEW_APPLICATION;
  const applicationType = applicationTypeFromLicenceSubType(licencingSubType);
  const applicationMode = APPLICATION_MODE_NEW

  const title = !isPrincipalBroker ? 
    "The applicant must complete the Nova Scotia Mortgage Broker Education Program within 1 year and provide a certificate of completion" :
    "You must complete the Nova Scotia Mortgage Broker Education Program within 1 year and provide a certificate of completion";

  const checkboxText = !isPrincipalBroker ? 
    "Yes, I confirm that the applicant will complete my education requirement within the next year and provide my certificate" :
    "Yes, I confirm that I will complete my education requirement within the next year and provide my certificate";

  return (
    <>
      <div className={"container"}>
        <TopNavigationBar {...props} applicationType={applicationType} applicationMode={applicationMode} />
        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <Header
              style={{ paddingBottom: "30px" }}
              id="complete-mortgage-education-header"
              header={title}
            />
            <Paragraph
              style={{ paddingBottom: "20px" }}
              id="complete-mortgage-education-text"
              text={[
                "Mortgage Brokers in Nova Scotia must complete the Nova Scotia Mortgage Broker Education Program before their licence renewal in October 2022.  They must provide their certificate of completion for this education requirement.",
              ]}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-lg-9">
            <CheckboxForm
              id="confirm-before-start-checkbox"
              checked={confirmCheck}
              value={confirmCheck}
              labelText={checkboxText}
              onCheckBoxChange={(val) => {
                setShowValidationError(false);
                setConfirmCheck(val);
              }}
            />
          </div>
        </div>

        <div className="row">
          <div
            className={"col-lg-4" + (showValidationError ? " has-error" : "")}
          >
            <Button
              id="complete-mortgage-education-continue-button"
              style={{ margin: "0 10px 10px 0" }}
              buttonType={"regular_primary"}
              text={"Save and next"}
              onClick={() => {

                setApplicationSaveError(false)

                if (!confirmCheck) {
                  setShowValidationError(true);
                  return;
                }

                setShowValidationError(false);

                // Set MORTGAGE PROP value
                dispatch(
                  setCurrentAgentMortgageProperty({
                    key: MORTGAGE_APPLICATION_PROPERTY,
                    value: true,
                  })
                );

                dispatch(saveBusinessLicenceApplicationData(
                  applicationType, APPLICATION_MODE_NEW))
                  .then(data => {
                    // On to the next item
                    const nextPath = !isPrincipalBroker ? ROUTE_PATH.MRA_UPLOAD_CRIMINAL_RECORD_CHECK : ROUTE_PATH.MRA_BROKER_CONTACT_INFORMATION;

                    dispatch(
                      push(`${ROUTE_PATH.MRA_APP}${nextPath}`)
                    );
                  })
                  .catch(err => {
                    setApplicationSaveError(true)
                  })
              }}
            />
            {(showValidationError || applicationSaveError) && ErrorMark()}
            {showValidationError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.CONFIRM_MORTGAGE_EDUCATION_REQUIREMENT}
              </div>
            )}
            {applicationSaveError && (
              <div className="ns-error-message">
                <span className="ns-visually-hidden">Error:</span>
                {ERROR_STRING.APPLICATION_SAVE_ERROR}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};
